import { render, staticRenderFns } from "./PayCard.vue?vue&type=template&id=2b3efbe8&scoped=true"
import script from "./PayCard.vue?vue&type=script&lang=js"
export * from "./PayCard.vue?vue&type=script&lang=js"
import style0 from "./PayCard.vue?vue&type=style&index=0&id=2b3efbe8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3efbe8",
  null
  
)

export default component.exports